import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import QRCode from 'react-qr-code';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { Modal } from '../../../components/Modal';
import { selectWork } from '../../Api/selectors';
import { REQUEST_VEHICLE_PROPERTY_UPDATE, VEHICLE_OPTIONS, VEHICLE_OPTIONS2 } from '../constants';
import { GeneratePdfButton } from '../../../components/GeneratePdfButton/GeneratePdfButton';
import { HBox, VBox } from '../../../components/Box';
import { selectAllOptions } from '../selectors';
import { formatCurrencyValue, formatLicensePlate } from '../../../utils/string';
import env from '../../../env';
import { AppClientId } from '../../Shared/constants';
import { Loader } from '../../../components/Loader';

const Container = styled.div`
  font-size: 18px;
  margin: 10px auto;
  font-family: arial;
  width: 1400px;
  height: 1754px;
  background-color: white;
  color: black;

  .doc-main {
    color: black;
    font-weight: 400;
    padding: 150px 150px 75px 150px;
  }

  .title {
    font-size: 65px;
    text-transform: uppercase;
  }

  .title1 {
    font-size: 65px;
    width: 120%;

  }

  .vehicle-info-section {
    font-size: 30px;
    margin-bottom: 30px;
  }

  .options-section {
    font-size: 30px;
    margin-bottom: 90px;
    text-transform: capitalize;
    min-height: 600px;
    // background-color: red;

  }



  }

  .b2b-price-section {
    align-items: baseline;
    margin-bottom: 48px;
    margin-top: -60px;
    width: 200%;

  }

  .price-incl-options {
    width: 50%;
    font-size: 24px;
    margin-bottom: 50px;
  }

  .wegenbelasting {
    width: 50%;
    font-size: 24px;
    margin-bottom: 20px;
    align: left;
  }

  .bottom-section {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: #fff; /* Adjust as needed */
    padding: 20px; /* Adjust as needed */
}
`;

const STATE = {};

const numberOfVehicleOptions = VEHICLE_OPTIONS ? VEHICLE_OPTIONS.length : 0;

/* eslint-disable react/prefer-stateless-function */
class PdfPreviewComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  roadTax(str) {
    if (!str) return { min: 0, max: 0 };

    // € 67 / € 268 or € 229 / € 916
    let arr1 = str
      .split('/')[1]
      .split(/[^\d]+/)
      .filter(Boolean)
      .map(s => parseInt(s, 10));

    return {
      min: Math.min(...arr1), // Get the minimum value
      max: Math.max(...arr1), // Get the maximum value
    };
  }

  renderOption(value, index) {
    if (value.title) {
      return null;
    }

    let options = this.props.allOptions?.filter(o => o.name.toLowerCase() === value.toLowerCase());

    let vehicleHasOption;
    let optionsRendered = 0; // Counter for options rendered

    for (let i = 0; i < options?.length || 0; i++) {
      for (let j = 0; j < this.props.vehicle.options?.length || 0; j++) {
        let o1 = options[i];
        let o2 = this.props.vehicle.options[j];
        if (o1.id == o2.id && o2.VehicleHasOption.isSelected) {
          vehicleHasOption = o2;
          if (value == 'airco') {
            //
          }
        }
      }
    }

    if (vehicleHasOption) options = this.props.allOptions?.find(o => o.autotelexId == vehicleHasOption.autotelexId);

    vehicleHasOption = vehicleHasOption?.VehicleHasOption?.isSelected ? vehicleHasOption : null;

    if (!vehicleHasOption) return null;

    // Check if the maximum number of options has been rendered
    if (optionsRendered < 12) {
      optionsRendered++;

      return <div style={{ width: '50%', fontSize: '30px' }}> &#8226; {value}</div>;
    } else {
      return null; // Return null for options beyond the first 12
    }
  }

  render() {
    const vehicle = this.props.vehicle;
    const brandAndModel = `${vehicle.brand_name ?? ''} ${vehicle?.model_name ?? ''}`;
    const truncatedBrandAndModel = truncateAndExcludeLastWord(brandAndModel, 24);
    const modelInfo = `${vehicle.model_info ?? ''}`;
    const truncatedModelInfo = truncateAndExcludeLastWord(modelInfo, 30);
    const lowestNumber = getLowestNumber(`${vehicle.wegenbelasting ?? '0'}`);
    const vehiclePurpose =
      vehicle?.properties.find(p => p?.propertyName?.name === 'vehicle_purpose')?.propertyValue?.value ?? null;
      const optionsLength = (VEHICLE_OPTIONS
        ?.map((value, index) => this.renderOption(value, index))
        .filter(Boolean)
        .length
        );
        const numberShown = 24 - optionsLength
    return (
      <Modal pdfView onClose={this.props.onClose}>
        {this.state.isLoading ? (
          <Modal>
            <HBox center vCenter>
              <Loader />
            </HBox>
          </Modal>
        ) : (
          <Container>
            <VBox id={'pricecard_doc'} className="doc-main">
              <div style={{ marginBottom: '30px', marginTop: '80px' }}>
                <h2 className="title">{truncatedBrandAndModel}</h2>
                <h2 className="title1">{truncatedModelInfo}</h2>
              </div>
              <HBox left className="vehicle-info-section">
                <VBox>
                  {[
                    'regplate',
                    'date_first_allowance',
                    'fuel_type',
                    'mileage',
                    'transmission_type',
                    'euro_class',
                    'cyllinder_capacity',
                    'power',
                    'vin',
                  ].map(property => {
                    return (
                      vehicle[property] && (
                        <HBox key={property}>
                          <div style={{ fontSize: '30px'}}>{this.lbl(`vehicle.property.pricecard.${property}`)}:</div>
                          <div style={{ textAlign: 'left', width: '50%', textTransform: 'capitalize', fontSize: '30px'}}>
                            {property === 'regplate'
                              ? formatLicensePlate(vehicle.regplate)
                              : property === 'mileage'
                              ? parseInt(vehicle.mileage || '0').toLocaleString() + ' km'
                              : vehicle[property]}
                          </div>
                        </HBox>
                      )
                    );
                  })}
                </VBox>
              </HBox>
              <div style={{ marginBottom: '12px', fontSize: '30px' }}>{this.lbl('vehicle.details.pdf.options')}: </div>
              <HBox className="options-section">
                <HBox classname="capitalize-first-letter"  flexWrap>
                {VEHICLE_OPTIONS
                        ?.map((value, index) => this.renderOption(value, index))
                        .filter(Boolean)
                        .slice(0, 24)}
  
                        {optionsLength < 10 && 
                       
                       VEHICLE_OPTIONS2
                        ?.map((value, index) => this.renderOption(value, index))
                        .filter(Boolean)
                        .slice(0, numberShown)
                       }    
                </HBox>
              </HBox>
              <HBox vCenter>
                {vehiclePurpose === 'commercial' ? (
                  vehicle?.financial_price_b2c ? (
                    <HBox left className="b2b-price-section">
                      <h2 style={{ fontSize: '600%' }}>{formatCurrencyValue(vehicle?.financial_price_b2c)},-&nbsp;</h2>
                      {vehicle.tax_type !== 'marge' ? (
                        <span style={{ fontSize: '400%' }}>{this.lbl('vehicle.details.pdf.excl-btw')}</span>
                      ) : (
                        ''
                      )}
                    </HBox>
                  ) : (
                    <HBox left className="b2b-price-section">
                      <h2 style={{ fontSize: '700%' }}>€ ---,-</h2>
                      {vehicle.tax_type !== 'marge' ? (
                        <span style={{ fontSize: '400%' }}>{this.lbl('vehicle.details.pdf.excl-btw')}</span>
                      ) : (
                        ''
                      )}
                    </HBox>
                  )
                ) : vehicle?.financial_price_b2c ? (
                  <HBox left className="b2b-price-section">
                    <h2 style={{ fontSize: '700%' }}>{formatCurrencyValue(vehicle?.financial_price_b2c)},-&nbsp;</h2>
                    {vehicle.tax_type !== 'marge' ? (
                      <span style={{ fontSize: '400%' }}>{this.lbl('vehicle.details.pdf.incl-btw')}</span>
                    ) : (
                      ''
                    )}
                  </HBox>
                ) : (
                  <HBox left className="b2b-price-section">
                    <h2 style={{ fontSize: '700%' }}>€ ---,-</h2>
                    {vehicle.tax_type !== 'marge' ? (
                      <span style={{ fontSize: '400%' }}>{this.lbl('vehicle.details.pdf.incl-btw')}</span>
                    ) : (
                      ''
                    )}
                  </HBox>
                )}

                <div style={{ height: 'auto', maxWidth: '100%', width: '100%', marginTop: '-80px' }}>
                  {' '}
                  {env.clientId === AppClientId.AUTOWIENTJES ? (
                    <QRCode
                      size={400}
                      style={{ height: 'auto', maxWidth: '60%', width: '60%' }}
                      value={`https://www.autowientjes.nl/occasions/?merk=${vehicle?.brand_name.replace(/ /g, '-')}`}
                      viewBox={`0 0 256 256`}
                    />
                  ) : env.clientId === AppClientId.HARRY_NIJBOER ? (
                    <QRCode
                      size={400}
                      style={{ height: 'auto', maxWidth: '60%', width: '60%' }}
                      value={`https://www.harrynijboer.nl/occasions?brand=${vehicle?.brand_name.replace(/ /g, '-')}`}
                      viewBox={`0 0 256 256`}
                    />
                  ) : env.clientId === AppClientId.AUTOHUISSALLAND ? (
                    <QRCode
                      size={400}
                      style={{ height: 'auto', maxWidth: '60%', width: '60%' }}
                      value={`https://www.autohuissalland.nl/aanbod-occasions`}
                      viewBox={`0 0 256 256`}
                    />
                  ) : null}
                </div>
              </HBox>

              <div style={{ textAlign: 'left', width: '100%', marginTop: '-50px', fontSize: '30px' }}>
                {vehicle?.wegenbelasting ? (
                  <>
                    <HBox className="wegenbelasting">
                      <div style={{ width: '300px', fontSize: '30px' }}>{this.lbl('vehicle.details.pdf.wegenbelasting')}: </div>
                      <div style={{ width: '300px', fontSize: '30px' }}>
                        {formatCurrencyValue(lowestNumber)}&nbsp;
                        {this.lbl('vehicle.details.pdf.perkwartaal')}
                      </div>
                    </HBox>{' '}
                  </>
                ) : (
                  <HBox className="wegenbelasting">
                    <div style={{ width: '300px', fontSize: '30px' }}>&nbsp;</div>
                    <div style={{ width: '300px', fontSize: '30px' }}></div>
                  </HBox>
                )}
                {vehicle?.catalogprice_incl_options ? (
                  <>
                    <HBox className="price-incl-options">
                      <div style={{ width: '300px', fontSize: '30px' }}>{this.lbl('vehicle.details.pdf.price-incl-opt')}:</div>
                      <div style={{ width: '300px', fontSize: '30px' }}>{formatCurrencyValue(vehicle?.catalogprice_incl_options)}</div>
                    </HBox>
                  </>
                ) : (
                  <HBox className="price-incl-options">
                    <div style={{ width: '300px', fontSize: '30px' }}>&nbsp;</div>
                    <div style={{ width: '300px', fontSize: '30px' }}></div>
                  </HBox>
                )}
              </div>
              <VBox center>
                <div style={{ fontFamily: 'Arial', fontWeight: '200', fontSize: '20px' }}>{this.lbl('vehicle.details.pdf.footer-text')}</div>
              </VBox>
            </VBox>
          </Container>
        )}
        <GeneratePdfButton
          generateDirectly
          sectionId={'pricecard_doc'}
          label={'PDF'}
          widthMn={210}
          heightMm={297}
          closeModal={this.props.onClose}
          setLoading={loading => this.setState({ isLoading: loading })}
        />
      </Modal>
    );
  }
}

PdfPreviewComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  vehicle: PropTypes.object,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    loadingChecks: selectWork(REQUEST_VEHICLE_PROPERTY_UPDATE),
    allOptions: selectAllOptions(),
  });

function truncateAndExcludeLastWord(inputString, maxLength) {
  // Controleer of de inputString de maximale lengte niet overschrijdt
  if (inputString.length <= maxLength) {
    return inputString;
  }

  // Zoek de laatste spatie vóór de maximale lengte
  let lastSpaceIndex = inputString.lastIndexOf(' ', maxLength);

  // Als er geen spatie is gevonden, gebruik dan de maximale lengte
  if (lastSpaceIndex === -1) {
    lastSpaceIndex = maxLength;
  }

  // Knip de string af op het laatste spatiepunt
  const truncatedString = inputString.substring(0, lastSpaceIndex);

  return truncatedString;
}

function getLowestNumber(inputString) {
  // Extract numbers from the input string
  const numbers = inputString.match(/\d+/g);

  // Convert the extracted numbers to an array of integers
  const numericValues = numbers.map(value => parseInt(value, 10));

  // Find the minimum value
  const min = Math.min(...numericValues);

  return min;
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const PdfPreview = compose(withConnect, withRouter)(PdfPreviewComp);
